import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IGlobalMessagePublic } from '@app/core/interfaces/IGlobalMessage';


@Component({
  standalone: false,
  selector: 'messages-dialog-component',
  template: `
    <header class="message-header">
      <h2 mat-dialog-title>{{data.Headline}}</h2>
      <button mat-icon-button type="button" class="message-close"
              aria-label="Stäng meddelandet" matTooltip="Stäng"
              (click)="onCloseClick()">
        <mat-icon>close</mat-icon>
      </button>
    </header>
    <mat-dialog-content class="message-content">{{data.Content}}</mat-dialog-content>
  `,
  styles: [`
    :host {
      display: block;
      min-width: 0;
    }

    @media (min-width: 981px) {
      :host {
        min-height: 250px;
      }
    }

    .message-header {
      display: flex;
      align-items: flex-start;
      gap: 8px;
      margin-bottom: 16px;
    }

    .message-header h2 {
      flex: 1;
      min-width: 0;
      margin: 0;
      padding: 10px 0 0;
      font-size: 22px;
      font-weight: 700;
      line-height: 1.3;
      overflow-wrap: anywhere;
    }

    .message-header h2::before {
      display: none;
    }

    .message-close {
      flex: 0 0 48px;
      width: 48px;
      height: 48px;
      padding: 12px;
      border-radius: 0;
      color: #111827;
    }

    .message-close mat-icon {
      width: 22px;
      height: 22px;
      font-size: 22px;
    }

    .message-content {
      margin: 0;
      padding: 0;
      color: #111827;
      font-size: 15px;
      line-height: 1.6;
      letter-spacing: normal;
      white-space: pre-line;
      overflow-wrap: anywhere;
    }
  `]
})


export class MessagesDialogComponent {
  public message: IGlobalMessagePublic;
  constructor(
    public dialogRef: MatDialogRef<MessagesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IGlobalMessagePublic,
  ) { }

  onCloseClick(): void {
    this.dialogRef.close();
  }

}


